import { BlockWrapper } from '@smartfire/js-block-engine'
import style from './block.module.scss'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useState, useEffect } from 'react'
import clsx from 'clsx'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { useTranslation } from 'react-i18next'

const Block = ({ summary }) => {
    const { t } = useTranslation()
    const [open, setOpen] = useState(false)
    const [active, setActive] = useState(0)
    const [positionList, setPositionList] = useState([])
    const isTablet = useMediaQuery(`(max-width : ${style.tabletBreakpoint})`)

    useEffect(() => {
        setPositionList(
            summary.map((el, i) => {
                var anchor = document.getElementById(el.anchor)
                return { anchorIndex: i, pos: anchor ? anchor.offsetTop : 0 }
            }),
        )
    }, [summary])

    useEffect(() => {
        const getNearestAnchor = () => {
            var nearest = 0
            var scroll = document.documentElement.scrollTop
            positionList.forEach((el) => {
                if (scroll > el.pos) nearest = el.anchorIndex
            })
            setActive(nearest)
        }

        window.addEventListener('scroll', getNearestAnchor)
        return () => window.removeEventListener('scroll', getNearestAnchor)
    }, [positionList])

    return (
        <>
            {isTablet ? (
                <BlockWrapper.Div className={style.blockMobile}>
                    <div className={style.summaryTitle} onClick={() => setOpen(!open)}>
                        <div>{t('Sommaire')}</div>
                        <ArrowDropDownIcon className={clsx(style.arrow, open && style.turn)} />
                    </div>
                    <div className={clsx(style.summary, open && style.show)}>
                        {summary.map((el, i) => (
                            <a
                                key={i}
                                onClick={() => {
                                    setOpen(!open)
                                }}
                                className={clsx(
                                    style.anchor,
                                    i === active && style.last,
                                    el.levelTag === 'h3' && style.thirdLevel,
                                )}
                                href={'#' + el.anchor}
                                dangerouslySetInnerHTML={{ __html: el.title }}
                            />
                        ))}
                    </div>
                </BlockWrapper.Div>
            ) : (
                <BlockWrapper.Div className={style.block}>
                    {summary.map((el, i) => (
                        <a
                            key={i}
                            className={clsx(
                                style.anchor,
                                i === active && style.last,
                                el.levelTag === 'h3' && style.thirdLevel,
                            )}
                            href={'#' + el.anchor}
                            dangerouslySetInnerHTML={{ __html: el.title }}
                        />
                    ))}
                </BlockWrapper.Div>
            )}
        </>
    )
}

export default Block
